export default {
  addressColor: '',
  ammenityIconFill: Styles.color.black,
  innerAnchorColor: '',
  innerColor: '',
  innerPColor: '',
  modalBackground: Styles.color.white,
  phoneNumberColor: Styles.color.black,
};
